module.exports = __webpack_public_path__ + "static/img/T7399.f340e934.png";